import { priceSourcesApi } from 'app/services/api';
import _ from 'lodash';

import { createNamedActions } from 'utils/namedActionTypesProxy';

import { extractErrorMessage } from '../marginCenter.actionUtils';

export const PRICE_SOURCE_MATRICES_ACTION_TYPE = createNamedActions(
  'marginCenter/priceSourceMatrices',
  {
    SET_VERSIONS_LOADING: 'SET_VERSIONS_LOADING',
    GET_VERSIONS: 'GET_VERSIONS',
    SET_VERSIONS_ERROR: 'SET_VERSIONS_ERROR',
    SET_VERSION_LOADING: 'SET_VERSION_LOADING',
    GET_VERSION: 'GET_VERSION',
    SET_VERSION_ERROR: 'SET_VERSION_ERROR',
    SET_DEACTIVATING: 'SET_DEACTIVATING',
    SET_DEACTIVATED: 'SET_DEACTIVATED',
    SET_DEACTIVATE_ERROR: 'SET_DEACTIVATE_ERROR',
    SET_SRP_MATRIX_LOADING: 'SET_SRP_MATRIX_LOADING',
    GET_SRP_MATRIX: 'GET_SRP_MATRIX',
    SET_SRP_MATRIX_ERROR: 'SET_SRP_MATRIX_ERROR',
    CLEAR_SRP_MATRIX: 'CLEAR_SRP_MATRIX',
  },
);

const MATRIX_VERSION_HISTORY_TAKE = 10;

export const getPriceSourceMatrixVersionsAction = priceSourceId => async dispatch => {
  dispatch({ type: PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_VERSIONS_LOADING });

  try {
    const { data } = await priceSourcesApi.getMatrixVersions(priceSourceId, {
      take: MATRIX_VERSION_HISTORY_TAKE,
    });

    return dispatch({
      type: PRICE_SOURCE_MATRICES_ACTION_TYPE.GET_VERSIONS,
      payload: data ?? [],
    });
  } catch {
    return dispatch({ type: PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_VERSIONS_ERROR });
  }
};

export const getPriceSourceMatrixVersionAction =
  ({ priceSourceId, versionId }) =>
  async dispatch => {
    dispatch({ type: PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_VERSION_LOADING, payload: versionId });

    try {
      const { data } = await priceSourcesApi.getMatrixVersion(priceSourceId, versionId);

      return dispatch({
        type: PRICE_SOURCE_MATRICES_ACTION_TYPE.GET_VERSION,
        payload: { versionId, data },
      });
    } catch (error) {
      return dispatch({
        type: PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_VERSION_ERROR,
        payload: { versionId, errorMessage: extractErrorMessage(error) },
      });
    }
  };

// Turning matrices off deactivates the serving version: with no Active version no matrix applies to
// the source's quotes. The history is re-read so the card shows the version as Deactivated.
export const deactivatePriceSourceMatrixVersionAction =
  ({ priceSourceId, versionId }) =>
  async dispatch => {
    dispatch({ type: PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_DEACTIVATING, payload: versionId });

    try {
      const { data } = await priceSourcesApi.deactivateMatrixVersion(priceSourceId, versionId);

      await dispatch(getPriceSourceMatrixVersionsAction(priceSourceId));
      dispatch({ type: PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_DEACTIVATED });

      return data ?? null;
    } catch (error) {
      dispatch({
        type: PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_DEACTIVATE_ERROR,
        payload: extractErrorMessage(error),
      });

      return null;
    }
  };

// The rate-sheet SRP explorer re-reads on every product change, so responses can land out of order:
// each request carries an id and the reducer keeps only the latest one's response.
export const getPriceSourceVersionSrpMatrixAction =
  ({ priceSourceId, versionId, filters = {} }) =>
  async dispatch => {
    const requestId = _.uniqueId('version-srp-matrix-');

    dispatch({
      type: PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_SRP_MATRIX_LOADING,
      payload: { versionId, requestId },
    });

    try {
      const { data } = await priceSourcesApi.getVersionSrpMatrix(priceSourceId, versionId, filters);

      return dispatch({
        type: PRICE_SOURCE_MATRICES_ACTION_TYPE.GET_SRP_MATRIX,
        payload: { versionId, requestId, data },
      });
    } catch (error) {
      return dispatch({
        type: PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_SRP_MATRIX_ERROR,
        payload: { versionId, requestId, errorMessage: extractErrorMessage(error) },
      });
    }
  };

export const clearPriceSourceVersionSrpMatrixAction = () => ({
  type: PRICE_SOURCE_MATRICES_ACTION_TYPE.CLEAR_SRP_MATRIX,
});
